import { Component, Input, OnInit } from '@angular/core';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { FormArray, FormControl, FormControlName, FormGroup, FormGroupDirective } from '@angular/forms';
import { ICSourceData } from './input-counter-order.interface';

@Component({
  selector: 'app-input-counter-order',
  templateUrl: './input-counter-order.component.html',
  styleUrls: ['./input-counter-order.component.scss'],
})
export class InputCounterOrderComponent implements OnInit {
  @Input() fieldIndex: number;
  @Input() isGudangMostRequest = false;
  @Input() sourceData: ICSourceData[];
  @Input() loadingFetch: boolean;
  @Input() availableStockFormName: string = 'available_stock';
  @Input() orderItemQty: string = 'order_item';
  @Input() disableInput!: boolean;
  @Input() withValidateStock: boolean = true;

  form: FormGroup;
  counter: FormControl;

  get counterValue() {
    return this.formatValue(this.counter.value);
  }

  get products() {
    const _name = Object.keys(this.form.controls)[0];
    return <FormArray>this.form.get(_name);
  }

  get qtyAvailable() {
    return this.products.at(this.fieldIndex).get(this.availableStockFormName);
  }

  // get qtyFullFilled() {
  //   return this.products.at(this.fieldIndex).get('qty_fullfilled');
  // }

  get qtyOrder() {
    return this.products.at(this.fieldIndex).get('order_item');
  }

  constructor(
    private formGroupDirective: FormGroupDirective,
    private formControlNameDirective: FormControlName
  ) {}

  ngOnInit() {
    this.form = this.formGroupDirective.form;
    this.counter = this.formGroupDirective.getControl(this.formControlNameDirective);
  }

  increment() {
    let _count = this.counterValue ? this.counterValue : 0;
    _count++;

    this.patchCounterValue(_count);
  }

  decrement() {
    const _count = this.counterValue - 1;
    this.patchCounterValue(_count);
  }

  handleChangeInput() {
    let _val = this.counterValue;
    const { available_stock, order_item } = this.sourceData[this.fieldIndex];
    if (!this.isValidQtyFullFilled()) _val = order_item;
    if (this.withValidateStock && this.isStockLessThanOrderQty() && _val > available_stock) _val = available_stock;
    this.patchCounterValue(_val);
  }

  inputShouldDisabled = () => {
    if (this.loadingFetch) return true;
    if (this.disableInput) return this.disableInput;
    const sourceData = this.sourceData[this.fieldIndex];
    return this.isGudangMostRequest || !sourceData.available_stock
      ? !this.isValidQtyFullFilled() && this.counterValue < 1
      : this.isValidQtyFullFilled() && sourceData.available_stock < 1;
  };

  buttonAddShouldDisabled() {
    if (this.loadingFetch) return true;

    const sourceData = this.sourceData[this.fieldIndex];
    if (!this.isGudangMostRequest && this.withValidateStock && sourceData.available_stock <= 0) return true;

    return this.isGudangMostRequest || !sourceData.available_stock || !this.withValidateStock
      ? this.counterValue >= sourceData.order_item
      : this.counterValue >= sourceData.order_item || this.counterValue >= sourceData.available_stock;
  }

  patchCounterValue = (val: number) => {
    this.counter.patchValue(val);
    this.calculateQtyOrder();
  };

  calculateQtyOrder() {
    const _qty = this.sourceData[this.fieldIndex].order_item - this.counterValue;
    this.patchQtyOrderValue(_qty);
  }

  patchQtyOrderValue(val: number) {
    this.qtyOrder?.patchValue(val);
    this.calculateAvailableStock();
  }

  calculateAvailableStock() {
    const _qty = this.sourceData[this.fieldIndex].available_stock - this.counterValue;
    this.qtyAvailable?.patchValue(_qty);
  }

  formatValue(value: string) {
    if (value) {
      const _val = value.toString().replace(/\D/g, '').replace(/^0+/, '');
      return +_val;
    }
    return 0;
  }

  isValidQtyFullFilled = () => {
    // if selected gudang from parent is most request: value of available stock here will be null
    // user can input qty with maximum limitation of the order_item qty
    // let { available_stock, order_item } = this.sourceData[this.fieldIndex];
    const sourceData = this.sourceData[this.fieldIndex];
    if (this.isGudangMostRequest || !sourceData.available_stock || !this.withValidateStock) return this.counterValue <= sourceData.order_item;
    return this.counterValue <= sourceData.available_stock && this.counterValue <= sourceData.order_item;
  };

  isStockLessThanOrderQty() {
    const { available_stock, order_item } = this.sourceData[this.fieldIndex];
    return available_stock && available_stock > 0 && available_stock < order_item;
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
